import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useLeasingContacts from '../useLeasingContacts';
import { useRecoilValue } from 'recoil';
import { getPage } from 'hooks/useUser';
import Filters from 'components/filters';
import { ExcelIcon } from 'icons';

const MainPage = () => {
  const navigate = useNavigate();
  const {
    data,
    columns,
    loading,
    onDelete,
    updateInProcess,
    onChangeTableFilter,
    filters,
    handleDownloadExcel,
  } = useLeasingContacts();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  return (
    <>
      <PageHeader title={t('ELENCO CONTATTI COMMERCIALI').toUpperCase()}>
        <Row gutter={16}>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.contacts}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 1500 }}
          onRow={handleOnRow}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
